import { Component } from '@angular/core';

@Component({
  selector: 'uni-widget-container',
  templateUrl: './uni-widget-container.component.html',
  styleUrls: ['./uni-widget-container.component.scss'],
})
export class UniWidgetContainerComponent {
}
